import React from 'react'

import {
  FlatButton,
  Menu,
  MenuItem,
  Popover,
  Toggle
} from 'material-ui'

import { CardActions } from 'material-ui/Card'
import ContentAdd from 'material-ui/svg-icons/content/add'
import ContentFilter from 'material-ui/svg-icons/content/filter-list'
import ExportActions from './export-actions'

const cardActionsStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
  padding: '14px 0',
  marginRight: -8
}

const Actions = (props) => (
  <div>
    <CardActions style={cardActionsStyle}>
      {props.filters.length && <FlatButton onClick={props.handleFilterMenuOpen} icon={<ContentFilter />} title='Filter' />}
      <FlatButton onClick={props.handleCreate} icon={<ContentAdd />} title={props.createNewLabel || 'Create New'} style={{ display: props.hideCreate ? 'none' : '' }}>
        {props.createNewLabel && <span style={{ padding: '0 5px' }}>{props.createNewLabel}</span>}
      </FlatButton>
      {props.customActions.map((customAction, i) => (
        <FlatButton onClick={customAction.handleTap} icon={customAction.icon} title={customAction.title} style={{}} key={i} />
      ))}
      <ExportActions
        options={props.exportOptions}
        isExporting={props.isExporting}
        handleExport={props.handleExport}
      />
    </CardActions>
    <Popover
      open={props.filterMenuOpen}
      anchorEl={props.filterAnchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      targetOrigin={{ horizontal: 'left', vertical: 'top' }}
      onRequestClose={props.handleFilterMenuClose}
    >
      <Menu>
        {props.filters.map((filter, i) => (
          filter.name ? <MenuItem key={filter.name} onClick={props.handleFilterTap.bind(null, i, filter)} style={{ minHeight: 0, padding: '10px 0' }}>
            <Toggle toggled={filter.enabled} label={filter.name} />
          </MenuItem> : ''
        ))}
      </Menu>
    </Popover>
  </div>
)

// @ts-ignore
Actions.defaultProps = {
  customActions: []
}
// @ts-ignore
Actions.propTypes = {
  createNewLabel: React.PropTypes.string,
  customActions: React.PropTypes.array,
  filters: React.PropTypes.array.isRequired,
  filterMenuOpen: React.PropTypes.bool,
  filterAnchorEl: React.PropTypes.object,
  handleCreate: React.PropTypes.func,
  handleFilterMenuOpen: React.PropTypes.func.isRequired,
  handleFilterMenuClose: React.PropTypes.func.isRequired,
  handleFilterTap: React.PropTypes.func.isRequired,
  handleExport: React.PropTypes.func.isRequired,
  exportOptions: React.PropTypes.arrayOf(React.PropTypes.object),
  isExporting: React.PropTypes.bool
}

export default Actions
